import { GeneralModel } from "./general.model";

export class Structure extends GeneralModel {
    name: string;
    vseOracleCode: string;
}


// WEBPACK FOOTER //
// D:/SSW/Project/GSDP/Angular/gsdp_core_angular/src/app/models/structure.model.ts